import {
  STUDIES_DIALOG,
  PATIENT_JACKET_PRIORS,
  SEARCH_JACKET_PRIORS,
  PUBLIC_WORKLIST,
  PRIVATE_WORKLIST,
} from 'config/constants';
import type { GetCustomWorklistsQuery, GetWorklistQuery } from 'generated/graphql';

export const WorklistSurface = Object.freeze({
  MY_QUEUE: 'MY_QUEUE',
  QC: 'QC',
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  RECENTLY_READ: 'RECENTLY_READ',
  ARCHIVE: 'ARCHIVE',
  STUDIES_DIALOG: STUDIES_DIALOG,
  PATIENT_JACKET_PRIORS: PATIENT_JACKET_PRIORS,
  SEARCH_JACKET_PRIORS: SEARCH_JACKET_PRIORS,
  PLACEHOLDER: 'PLACEHOLDER',
  CUSTOM_WORKLIST: 'CUSTOM_WORKLIST',
});

export type WorklistSurfaceType =
  | 'MY_QUEUE'
  | 'QC'
  | 'PENDING'
  | 'IN_PROGRESS'
  | 'RECENTLY_READ'
  | 'ARCHIVE'
  | 'STUDIES_DIALOG'
  | 'PATIENT_JACKET_PRIORS'
  | 'SEARCH_JACKET_PRIORS'
  | 'PLACEHOLDER'
  | 'CUSTOM_WORKLIST';

export type WorklistStatusWithLock =
  | 'Locked'
  | 'ADNDM Locked'
  | 'Queued'
  | 'ADNDM Queued'
  | 'Completed'
  | 'Verified'
  | 'Countdown'
  | 'ADNDM Countdown'
  | 'Externally Read'
  | 'QC';

export const WorklistSelection = Object.freeze({
  PRIVATE: PRIVATE_WORKLIST,
  PUBLIC: PUBLIC_WORKLIST,
});

export type WorklistSelectionType = (typeof WorklistSelection)[keyof typeof WorklistSelection];

export type WorklistColumnSortPreference = {
  column: string;
  desc: boolean;
};

export type PrivateWorklist = NonNullable<
  GetCustomWorklistsQuery['customWorklists']
>['privateWorklists'][number];

export type PublicWorklist = NonNullable<
  GetCustomWorklistsQuery['customWorklists']
>['publicWorklists'][number];

export type WorklistTableAddendum = NonNullable<
  NonNullable<
    NonNullable<GetWorklistQuery['worklistItems']['items'][number]>['report']
  >['addendums']
>[number];
